import { Mixin } from 'mixwith';
import { ELEMENTS } from 'Editor/services/consts';
import { ElementNodeBuilder } from 'Editor/services/Model';

export default Mixin(
  (superclass) =>
    class extends superclass {
       
      parseAuthorsNode(representation) {
        const builder = new ElementNodeBuilder();
        builder.addElementType(ELEMENTS.AuthorsElement.ELEMENT_TYPE);
        if (representation.attributes.parent_id) {
          builder.addParentId(representation.attributes.parent_id.nodeValue);
        }
        if (representation.attributes.id) {
          builder.addId(representation.attributes.id.nodeValue);
        }
        return builder.getNode();
      }
    },
);
